/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const futureStockDropdown = {
  header: 'Disponibilidade futura',
  quantity: 'Quantidade',
  noFutureStocks: 'Este produto não tem informações sobre disponibilidade futura.',
};

export const futureStock = {
  futureStockDropdown,
};
